class WohnreichQuiz extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.dialog = this.querySelector('dialog');
    this.launch = this.querySelector('.wrq-launch');
    this.form = this.querySelector('.wrq-play');
    this.strings = JSON.parse(this.querySelector('.wrq-translations').textContent);
    try { this.api = new URL(this.dataset.api, location.origin).href.replace(/\/$/, ''); if (new URL(this.api).protocol !== 'https:') return; } catch { return; }
    const fragment = new URLSearchParams(location.hash.slice(1));
    this.token = window.__wohnreichQuizToken || fragment.get('wohnreich-quiz');
    delete window.__wohnreichQuizToken;
    if (this.token) {
      fragment.delete('wohnreich-quiz');
      history.replaceState(null, '', location.pathname + location.search + (fragment.size ? '#' + fragment.toString() : ''));
    }
    this.launch.addEventListener('click', () => this.open());
    this.querySelector('.wrq-close').addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('close', () => {
      try { localStorage.setItem('wrq-dismissed', String(Date.now())); } catch {}
      cancelAnimationFrame(this.frame);
      this.querySelector('canvas').getContext('2d')?.clearRect(0, 0, 2000, 2000);
    });
    this.form.addEventListener('submit', (event) => this.play(event));
    this.querySelector('.wrq-start').addEventListener('click', () => this.startGame());
    this.querySelector('.wrq-round-form').addEventListener('submit', (event) => {event.preventDefault(); if (event.target.reportValidity()) this.gameAction('answer', new FormData(event.target).get('answer'));});
    this.querySelector('.wrq-continue').addEventListener('click', () => this.gameAction('continue'));
    this.querySelector('.wrq-bank').addEventListener('click', () => this.bankGame());
    this.querySelector('.wrq-share-native').addEventListener('click', async () => {
      try { if (navigator.share) await navigator.share({title: this.strings.share_title, text: this.strings.share_message, url: this.shareUrl}); else {await navigator.clipboard.writeText(this.shareUrl); this.status(this.strings.link_copied);} } catch {}
    });
    this.querySelector('.wrq-share-copy').addEventListener('click', async () => {try {await navigator.clipboard.writeText(this.shareUrl);this.status(this.strings.link_copied);} catch {this.status(this.strings.copy_failed);}});
    this.querySelector('.wrq-share-email').addEventListener('submit', (event) => {
      event.preventDefault(); if (!event.target.reportValidity()) return;
      const email = new FormData(event.target).get('friend');
      location.href = 'mailto:' + encodeURIComponent(email) + '?subject=' + encodeURIComponent(this.strings.share_title) + '&body=' + encodeURIComponent(this.strings.share_message + '\n\n' + this.shareUrl);
    });
    this.shareUrl = 'https://wuhnreich.com/?wohnreich-quiz=play';
    this.querySelector('.wrq-share-whatsapp').href = 'https://wa.me/?text=' + encodeURIComponent(this.strings.share_message + ' ' + this.shareUrl);
    this.querySelector('.wrq-share-facebook').href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.shareUrl);
    this.querySelector('.wrq-resend').addEventListener('click', () => this.play({preventDefault() {}}));
    this.querySelector('.wrq-change').addEventListener('click', () => {
      this.form.hidden = false; this.querySelector('.wrq-pending').hidden = true; this.status('');
      this.querySelector('#wrq-email').focus();
    });
    this.querySelector('.wrq-verify').addEventListener('click', () => this.verify());
    this.querySelector('.wrq-reward .wrq-copy').addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(this.reward.code);
        this.status(this.strings.copied);
      } catch { this.status(this.strings.copy_failed); }
    });
    this.onHashChange = () => {
      const fragment = new URLSearchParams(location.hash.slice(1));
      const value = fragment.get('wohnreich-quiz');
      if (!value) return;
      fragment.delete('wohnreich-quiz');
      history.replaceState(null, '', location.pathname + location.search + (fragment.size ? '#' + fragment.toString() : ''));
      this.activateToken(value);
    };
    window.addEventListener('hashchange', this.onHashChange);
    if (this.token) {
      this.activateToken(this.token);
      return;
    }
    this.initialize();
  }
  activateToken(value) {
    this.token = value; this.reward = null;
    this.confirmationReady = false;
    this.confirmLabel ||= this.querySelector('.wrq-verify').textContent;
    this.form.hidden = true;
    this.querySelector('.wrq-game').hidden = true;
    this.querySelector('.wrq-share').hidden = true;
    this.querySelector('.wrq-pending').hidden = true;
    this.querySelector('.wrq-reward').hidden = true;
    this.querySelector('.wrq-confirm').hidden = false;
    this.launch.hidden = false; this.status(''); this.open(); this.prepareConfirmation();
  }
  async request(path, body) {
    const response = await fetch(this.api + path, {
      method: body ? 'POST' : 'GET',
      headers: body ? {'Content-Type': 'application/json'} : {},
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'omit', referrerPolicy: 'no-referrer', signal: AbortSignal.timeout(20000)
    });
    const data = await response.json();
    if (!response.ok) {
      const error = new Error(data.error || 'error');
      error.publicKey = data.error || data.detail;
      throw error;
    }
    return data;
  }
  async initialize() {
    try {
      const data = await this.request('/question');
      this.question = data;
      this.form.hidden = Boolean(data.game);
      this.querySelector('.wrq-game').hidden = !data.game;
      this.querySelector('.wrq-start').hidden = !data.game;
      if (data.game) this.querySelector('.wrq-intro').textContent = this.strings.game_intro.replace('%rounds%', String(data.rounds)).replace('%step%', String(data.reward_step || 2));
      if (data.title) this.querySelector('h2').textContent = data.title;
      if (data.intro && !data.game) this.querySelector('.wrq-intro').textContent = data.intro;
      if (data.terms) this.querySelector('.wrq-terms').textContent = data.terms;
      if (data.delay) this.dataset.delay = data.delay;
      if (data.cooldown_days) this.dataset.cooldown = data.cooldown_days;
      this.form.querySelector('legend').textContent = data.question;
      for (const answer of data.game ? [] : data.answers) {
        const label = document.createElement('label');
        const input = document.createElement('input');
        input.type = 'radio'; input.name = 'answer'; input.value = answer.id; input.required = true;
        const span = document.createElement('span'); span.textContent = answer.text;
        label.append(input, span); this.form.querySelector('fieldset').append(label);
      }
      this.launch.hidden = false;
      if (new URLSearchParams(location.search).get('wohnreich-quiz') === 'play') {this.open(); return;}
      let dismissed = 0;
      try { dismissed = Number(localStorage.getItem('wrq-dismissed') || 0); } catch {}
      if (Date.now() - dismissed < Number(this.dataset.cooldown) * 86400000) return;
      this.timer = setTimeout(() => this.autoOpen(0), Number(this.dataset.delay) * 1000);
    } catch {}
  }
  autoOpen(attempt) {
    if (!this.isConnected || this.dialog.open) return;
    const blocked = document.hidden || [...document.querySelectorAll('[aria-modal="true"], #shopify-pc__banner, .shopify-pc__banner')]
      .some((element) => element !== this.dialog && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    if (blocked) {
      if (attempt < 12) this.timer = setTimeout(() => this.autoOpen(attempt + 1), 5000);
      return;
    }
    this.open();
  }
  open() { if (!this.dialog.open) this.dialog.showModal(); }
  status(message) { this.querySelector('.wrq-status').textContent = message; }
  failure(error) { this.status(this.strings[error.publicKey] || this.strings.error); }
  async startGame() {
    if (this.working) return;
    this.working = true;
    const button = this.querySelector('.wrq-start'); button.disabled = true;
    try {this.game = await this.request('/start', {question_id: this.question.id}); this.renderGame();} catch(error) {this.failure(error);}
    finally {this.working = false;button.disabled = false;}
  }
  async gameAction(action, answer = '') {
    if (this.working || !this.game) return;
    this.working = true; this.status('');
    const buttons = [...this.querySelectorAll('.wrq-game button')]; buttons.forEach(b => b.disabled = true);
    try {this.game = await this.request('/round', {game_token: this.game.game_token, round: this.game.round, action, answer}); this.renderGame();}
    catch(error) {this.failure(error);}
    finally {this.working = false;buttons.forEach(b => b.disabled = false);}
  }
  renderGame() {
    const g = this.game;
    this.querySelector('.wrq-start').hidden = true;
    const meter = this.querySelector('.wrq-meter'); meter.hidden = false;
    meter.setAttribute('aria-valuenow', g.status === 'lost' ? 0 : g.score); meter.setAttribute('aria-valuemax', g.total);
    meter.style.setProperty('--cozy-fill', (g.status === 'lost' ? 0 : g.score / g.total * 100) + '%');
    meter.classList.toggle('wrq-full', g.score === g.total);
    meter.classList.toggle('wrq-fallen', g.status === 'lost');
    this.querySelector('.wrq-meter-score').textContent = (g.status === 'lost' ? 0 : g.score) + ' / ' + g.total;
    this.querySelector('.wrq-levels').innerHTML = Array.from({length:g.total}, (_,i) => '<span class="' + (i < g.score && g.status !== 'lost' ? 'filled' : '') + '">' + ((i+1)*(g.reward_step || 2)) + '</span>').join('');
    const form = this.querySelector('.wrq-round-form'); form.hidden = g.status !== 'playing';
    const result = this.querySelector('.wrq-round-result'); result.hidden = g.status === 'playing';
    if (g.status === 'playing') {
      this.querySelector('.wrq-round-label').textContent = this.strings.round.replace('[round]',g.round+1).replace('[total]',g.total);
      const fieldset = form.querySelector('fieldset'); fieldset.replaceChildren();
      const legend = document.createElement('legend'); legend.textContent = g.question.question; fieldset.append(legend);
      for (const answer of g.question.answers) {
        const label = document.createElement('label'), input = document.createElement('input'), span = document.createElement('span');
        input.type = 'radio'; input.name = 'answer'; input.value = answer.id; input.required = true; span.textContent = answer.text; label.append(input,span);fieldset.append(label);
      }
    } else {
      const lost = g.status === 'lost';
      result.classList.toggle('wrq-oops',lost);
      this.querySelector('.wrq-yeah').textContent = lost ? this.strings.oops : 'YEAH!';
      this.querySelector('.wrq-round-amount').textContent = 'CHF ' + g.amount;
      this.querySelector('.wrq-round-message').textContent = lost ? this.strings.lost : g.status === 'won' ? this.strings.finished : this.strings.keep_playing;
      this.querySelector('.wrq-continue').hidden = g.status !== 'offer';
      this.querySelector('.wrq-bank').textContent = (g.status === 'offer' ? this.strings.bank : this.strings.claim).replace('[amount]',g.amount);
      this.querySelector('.wrq-risk').hidden = g.status !== 'offer';
      if (!lost && this.celebratedRound !== g.round) {this.celebratedRound = g.round;this.celebrate();}
    }
  }
  async bankGame() {
    if (!this.game || this.working) return;
    if (this.game.status === 'offer') await this.gameAction('bank');
    if (!this.game.finished) return;
    this.querySelector('.wrq-game').hidden = true;
    this.form.hidden = false;
    this.form.querySelector('fieldset').hidden = true;
    this.querySelector('.wrq-intro').textContent = this.strings.claim_intro.replace('[amount]',this.game.amount);
    this.querySelector('#wrq-email').focus();
  }
  async play(event) {
    event.preventDefault();
    if (this.working || !this.form.reportValidity()) return;
    this.working = true;
    const button = this.form.querySelector('button'); button.disabled = true;
    this.status('');
    try {
      const data = new FormData(this.form);
      await this.request('/enter', {question_id: this.question.id, answer: data.get('answer') || '', game_token: this.game?.game_token || '', email: data.get('email'), terms_accepted: data.has('terms_accepted'), newsletter: data.has('newsletter')});
      this.form.hidden = true;
      this.querySelector('.wrq-pending').hidden = false;
      this.querySelector('.wrq-change').hidden = Boolean(this.game);
      this.status(this.strings.sent);
      try { localStorage.setItem('wrq-dismissed', String(Date.now())); } catch {}
    } catch (error) { this.failure(error); }
    finally { button.disabled = false; this.working = false; }
  }
  async prepareConfirmation() {
    if (this.confirmationLoading) return;
    this.confirmationLoading = true;
    const button = this.querySelector('.wrq-verify'); button.disabled = true;
    this.status('');
    try {
      const data = await this.request('/confirmation', {token: this.token});
      this.querySelector('.wrq-terms').textContent = data.terms;
      this.querySelector('.wrq-confirm-newsletter').checked = data.newsletter;
      this.querySelector('.wrq-confirm-newsletter').disabled = Boolean(data.locked);
      this.querySelector('.wrq-intro').hidden = true;
      this.confirmationReady = true;
      button.textContent = this.confirmLabel;
      button.disabled = false;
    } catch(error) {
      this.failure(error);
      button.textContent = this.strings.retry_confirmation;
      button.disabled = error.publicKey === 'expired';
    } finally { this.confirmationLoading = false; }
  }
  async verify() {
    if (!this.confirmationReady) return this.prepareConfirmation();
    if (this.working) return;
    this.working = true;
    const button = this.querySelector('.wrq-verify'); button.disabled = true;
    this.status('');
    try {
      this.reward = await this.request('/verify', {token: this.token, newsletter: this.querySelector('.wrq-confirm-newsletter').checked});
      this.querySelector('.wrq-confirm').hidden = true;
      this.querySelector('.wrq-reward').hidden = false;
      this.querySelector('.wrq-result').textContent = this.strings[this.reward.correct ? 'correct' : 'incorrect'].replace('[amount]', this.reward.amount);
      if (this.reward.terms) this.querySelector('.wrq-terms').textContent = this.reward.terms;
      this.querySelector('.wrq-newsletter-status').hidden = !this.reward.newsletter;
      this.querySelector('.wrq-bound').hidden = !this.reward.customer_bound;
      this.querySelector('.wrq-amount').textContent = 'CHF ' + this.reward.amount;
      this.querySelector('.wrq-code').textContent = this.reward.code;
      this.querySelector('.wrq-shop').href = 'https://wuhnreich.com/discount/' + encodeURIComponent(this.reward.code) + '?redirect=' + encodeURIComponent(window.Shopify?.routes?.root || '/');
      this.querySelector('.wrq-expiry').textContent = this.strings.expiry + ' ' + new Date(this.reward.expires_at * 1000).toLocaleDateString(document.documentElement.lang);
      this.querySelector('.wrq-ticket').scrollIntoView({block: 'nearest'});
      this.celebrate();
      this.querySelector('.wrq-share').hidden = false;
    } catch (error) { this.failure(error); }
    finally { button.disabled = false; this.working = false; }
  }
  celebrate() {
    cancelAnimationFrame(this.frame);
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const canvas = this.querySelector('canvas'), context = canvas.getContext('2d');
    if (!context) return;
    const width = this.dialog.clientWidth, height = this.dialog.clientHeight;
    canvas.width = width * devicePixelRatio; canvas.height = height * devicePixelRatio;
    context.scale(devicePixelRatio, devicePixelRatio);
    const colors = ['#b99865', '#e6b4a0', '#786353', '#d5d9b6', '#f4d579'];
    const pieces = Array.from({length: 100}, (_, index) => ({
      x: index % 2 ? 0 : width, y: height * .7,
      vx: (index % 2 ? 1 : -1) * (3 + Math.random() * 5), vy: -6 - Math.random() * 8,
      angle: Math.random() * 6, color: colors[index % colors.length]
    }));
    const start = performance.now(); let previous = start;
    const draw = (now) => {
      const step = Math.min((now - previous) / 16.67, 3); previous = now;
      context.clearRect(0, 0, width, height);
      for (const p of pieces) {
        p.x += p.vx * step; p.y += p.vy * step; p.vy += .22 * step; p.angle += .07 * step;
        context.save(); context.translate(p.x, p.y); context.rotate(p.angle);
        context.fillStyle = p.color; context.fillRect(-3, -5, 6, 10); context.restore();
      }
      if (now - start < 3000 && this.dialog.open) this.frame = requestAnimationFrame(draw);
      else context.clearRect(0, 0, width, height);
    };
    this.frame = requestAnimationFrame(draw);
  }
  disconnectedCallback() { clearTimeout(this.timer); cancelAnimationFrame(this.frame); window.removeEventListener('hashchange', this.onHashChange); }
}
if (!customElements.get('wohnreich-quiz')) customElements.define('wohnreich-quiz', WohnreichQuiz);
